/**
 * Task #1510 — Tipo canonico per il seriale identitario di un prodotto.
 *
 * Schema sorgente (post-refactor #1475):
 *   pos_product_serials(id, tenant_id, unit_id, product_id, kind, value,
 *                       value_normalized, created_at)
 *
 * `value` è il valore così come l'utente l'ha inserito; `value_normalized` è la
 * forma canonica usata per UNIQUE(tenant_id, lower(value_normalized)) e per il
 * lookup scanner (MAC `aa:bb:..`, IMEI/ICCID solo cifre, generic trimmato).
 *
 * Lo stato logistico (status / warehouse_id / lot_id / unit_cost / carico_date)
 * NON vive su questa entità: è proprietà della unit ospitante
 * `pos_product_serial_units` referenziata da `unit_id`.
 */
import { z } from 'zod';

// `SerialKind` è già esportato come union string da `types/api.ts`
// (Task #1479): `'imei' | 'iccid' | 'macaddr' | 'serial'`. Qui esponiamo
// solo lo schema Zod corrispondente e l'entità `ProductSerial` post-#1475.
export const SerialKindSchema = z.enum(['imei', 'iccid', 'macaddr', 'serial']);

export const ProductSerialSchema = z.object({
  id: z.string().uuid(),
  product_id: z.string().uuid(),
  unit_id: z.string().uuid(),
  kind: SerialKindSchema,
  value: z.string().min(1).max(255),
  value_normalized: z.string().min(1).max(255),
  created_at: z.string(),
});

export type ProductSerial = z.infer<typeof ProductSerialSchema>;
